export const dateValueFormatter = (date) => {
        return date ? new Date(date * 1000).toLocaleString() : "";
    }

export const dateComparator = (valueA, valueB) => valueA - valueB;